export default __webpack_public_path__ + "static/media/img_delivery-min.0db39fc2.jpg";